export enum QueryRuleFormType {
  TEXT = 'text',
  DATE = 'date',
  SELECT = 'select',
  GROUP = 'group'
}

export interface QueryRuleFormKeyConfig {
  label?: string; // displayed label for the key
  queryRuleFormType: QueryRuleFormType; // overall type to help determine what operators or form component to display
  /**
   * Additional props for the form component.
   *
   * SELECT — provide a static options list (e.g. CWSJ LanguageCode):
   *   { options: [{ label: 'zh-cn', value: 'zh-cn' }, { label: 'zh-tw', value: 'zh-tw' }] }
   *
   * GROUP is defined but unused — falls back to the text input (no extra props needed).
   */
  formComponentProps?: any;
}
